var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1439_17672)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76859 12.7832H0.761452C0.339084 12.7832 0 12.434 0 12.0125V0.770727C0 0.349236 0.345033 0 0.761452 0H6.21654L9.53004 3.35387V12.0125C9.53004 12.44 9.18501 12.7832 8.76859 12.7832Z",
    fill: "#F8C56F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53021 3.35387H6.98411C6.56174 3.35387 6.22266 3.00463 6.22266 2.58314V0L9.53616 3.35387H9.53021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76068 5.88281C1.90346 5.88281 2.01648 5.99722 2.01648 6.14173C2.01648 6.28624 1.90346 6.40064 1.76068 6.40064C1.61791 6.40064 1.50488 6.28624 1.50488 6.14173C1.50488 5.99722 1.61791 5.88281 1.76068 5.88281Z",
    fill: "#0F3154"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76068 7.27374C1.90346 7.27374 2.01648 7.38815 2.01648 7.53266C2.01648 7.67717 1.90346 7.79157 1.76068 7.79157C1.61791 7.79157 1.50488 7.67717 1.50488 7.53266C1.50488 7.38815 1.61791 7.27374 1.76068 7.27374Z",
    fill: "#0F3154"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76068 8.75497C1.90346 8.75497 2.01648 8.86938 2.01648 9.01389C2.01648 9.1584 1.90346 9.27281 1.76068 9.27281C1.61791 9.27281 1.50488 9.1584 1.50488 9.01389C1.50488 8.86938 1.61791 8.75497 1.76068 8.75497Z",
    fill: "#0F3154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50792 6.01529H2.54004V6.27421H6.50792V6.01529Z",
    fill: "#0F3154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82915 7.4062H2.54004V7.66512H6.82915V7.4062Z",
    fill: "#0F3154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91898 8.88142H2.54004V9.14034H5.91898V8.88142Z",
    fill: "#0F3154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40004 13C9.28383 13 10.0003 12.2748 10.0003 11.3803C10.0003 10.4857 9.28383 9.76053 8.40004 9.76053C7.51626 9.76053 6.7998 10.4857 6.7998 11.3803C6.7998 12.2748 7.51626 13 8.40004 13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50195 11.5489V11.2117H9.29255V11.5489H7.50195ZM8.20987 12.3256V10.4409H8.59059V12.3256H8.20987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.20544 0.758682H0.571289V3.70912H5.20544V0.758682Z",
    fill: "#F8D479"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1439_17672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.0de0a2ca30b5287fd357b0f477809957.svg";
export { ForwardRef as ReactComponent };